/**
 * @fileoverview Hook de listagem de segmentos (listas salvas) com reload.
 */

import { useCallback, useEffect, useState } from "react";
import api from "../../services/api";

const useContactSegments = () => {
  const [segments, setSegments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.get("/contact-segments");
      setSegments(Array.isArray(data?.segments) ? data.segments : []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const create = useCallback(
    async (name, criteria) => {
      const { data } = await api.post("/contact-segments", { name, criteria });
      await refresh();
      return data;
    },
    [refresh]
  );

  const update = useCallback(
    async (id, body) => {
      const { data } = await api.put(`/contact-segments/${id}`, body);
      await refresh();
      return data;
    },
    [refresh]
  );

  const remove = useCallback(
    async (id) => {
      await api.delete(`/contact-segments/${id}`);
      await refresh();
    },
    [refresh]
  );

  const previewById = useCallback(async (id) => {
    const { data } = await api.get(`/contact-segments/${id}/preview`);
    return data;
  }, []);

  // Lista paginada dos contatos resolvidos pelo segment. mode='excluded'
  // retorna apenas os marcados como removidos pelo operador.
  const listSegmentContacts = useCallback(
    async (id, { pageNumber = 1, searchParam = "", mode } = {}) => {
      const params = { pageNumber };
      if (searchParam) params.searchParam = searchParam;
      if (mode) params.mode = mode;
      const { data } = await api.get(`/contact-segments/${id}/contacts`, { params });
      return data;
    },
    []
  );

  const excludeContact = useCallback(async (id, contactId) => {
    const { data } = await api.post(`/contact-segments/${id}/exclusions`, { contactId });
    return data;
  }, []);

  const restoreContact = useCallback(async (id, contactId) => {
    const { data } = await api.delete(
      `/contact-segments/${id}/exclusions/${contactId}`
    );
    return data;
  }, []);

  return {
    segments,
    loading,
    error,
    refresh,
    create,
    update,
    remove,
    previewById,
    listSegmentContacts,
    excludeContact,
    restoreContact
  };
};

export default useContactSegments;
